import { Component, ChangeDetectionStrategy, inject, input, output } from '@angular/core';

import { HostService } from '../../services/host-service';

@Component({
  selector: 'app-social-menu-header',
  templateUrl: './social-menu-header.component.html',
  styleUrls: ['./social-menu-header.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialMenuHeaderComponent {
  private hostService = inject(HostService);

  public readonly headerTitle = input('');
  public readonly showBackButton = input<boolean>();
  public readonly closeEvent = output<boolean>();
  public readonly backEvent = output<boolean>();

  public handleClose(): void {
    this.hostService.requestOpenGuestList$.next(false);
    this.closeEvent.emit(true);
  }

  public handleBack(): void {
    this.hostService.requestOpenGuestList$.next(false);
    this.backEvent.emit(true);
  }
}
